/* eslint-disable import/no-cycle */
import { adminApi as contentManagementApi } from '@/includes/contentManagementApi';
import FilesService from '@/services/filesService';

export default class NetworkAuth {
  static login(data, config) {
    return contentManagementApi.post('auth/login', data, config);
  }

  static refreshToken(data, config) {
    return contentManagementApi.post('auth/refresh', { refresh_token: data }, config);
  }

  static registerUser(data, config) {
    return contentManagementApi.post('auth/register', data, config);
  }

  static updateProfile(data, config) {
    return contentManagementApi.post('user/update', data, config);
  }

  // New unified endpoint for tag groups (replaces getTags and getTagQuestions)
  static getTagGroups(config) {
    return contentManagementApi.get('content/tag-groups', config);
  }

  static getUserInfo(config) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return contentManagementApi.post('user/info', { timezone }, config);
  }

  static async uploadProfilePicture(base64Image) {
    // Use FilesService which already uses the Files API endpoint
    // POST /files-api/files/upload-profile-picture
    const pictureProfile = await FilesService.uploadProfilePicture(base64Image);
    return { data: { success: true, picture_profile: pictureProfile } };
  }

  static validateRegisterData(data, config) {
    return contentManagementApi.post('auth/validate-registration', data, config);
  }

  static checkIfUserLoggedIn(data, config) {
    // Migrated to Monorepo endpoint
    // POST /content-management-api/user/ping/token
    return contentManagementApi.post('user/ping/token', data, config);
  }

  static requestPasswordReset(data, config) {
    return contentManagementApi.post('auth/forgot-password', data, config);
  }

  static setNewPassword(data, config) {
    return contentManagementApi.post('auth/reset-password', data, config);
  }

  static activateAccount(data, config) {
    return contentManagementApi.post('auth/activate', data, config);
  }

  /** Complete MCP OAuth after tenant login (Phase 4). Returns a one-time handoff id (not the client redirect URL). */
  static completeMcpOAuth(pendingId, config) {
    return contentManagementApi.post('oauth/complete', { pending_id: pendingId }, config);
  }

  /** Exchange OAuth handoff for the client redirect URL (authorization code only at redirect time). */
  static exchangeMcpOAuthHandoff(handoffId, config) {
    return contentManagementApi.post('oauth/handoff', { handoff_id: handoffId }, config);
  }

  /** Tenant admin CMS / MCP OAuth step-up: send email OTP. */
  static sendAdminStepUpOtp(config) {
    return contentManagementApi.post('auth/admin-step-up/send-otp', {}, config);
  }

  /** Tenant admin step-up: verify OTP and receive elevated JWT. */
  static verifyAdminStepUpOtp(data, config) {
    return contentManagementApi.post('auth/admin-step-up/verify-otp', data, config);
  }

  /**
   * Checks if a token is expired
   * @param token the jwt token
   * @param addSeconds miliseconds to add to the current time
   * @returns {boolean}
   */
  static isTokenExpired(token, addSeconds = 0) {
    try {
      // decode jwt
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(atob(base64).split('').map((c) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`).join(''));

      const payload = JSON.parse(jsonPayload);

      if (!payload || !payload.exp) {
        return true;
      }

      const expirationTime = payload.exp * 1000;
      const addedTime = Date.now() + addSeconds;
      return addedTime > expirationTime;
    } catch (error) {
      return true;
    }
  }
}
